import React from "react";
import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import { Amplify } from "aws-amplify";
import amplifyconfig from "./amplify_outputs.json";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";

Amplify.configure(amplifyconfig);

const App = () => {
  return (
    <AuthProvider>
      <AdminAuthProvider>
        <div className="app-container font-['GIL']">
          <AppRoutes />
          <Toaster />
        </div>
      </AdminAuthProvider>
    </AuthProvider>
  );
};

export default App;